export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./act-request.vue?vue&type=template&id=dc67a9fe&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/act-request.vue?vue&type=template&id=dc67a9fe&
// module id = 1413
// module chunks = 0